// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── LIVE TRAINING DUCK MODE (OLED ENERGY SAVER) ──────────────────────────
   Pure #000000 background to turn off OLED pixels and eliminate battery drain
   and thermal throttling while filming with the back camera.
   Wake lock remains active so the phone OS does not suspend the camera stream.
   ────────────────────────────────────────────────────────────────────────── */

.lt-duck-mode {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99999;
  background: #000000 !important;
  color: #64748b;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  padding: max(24px, env(safe-area-inset-top, 24px))
    max(24px, env(safe-area-inset-right, 24px))
    max(28px, env(safe-area-inset-bottom, 28px))
    max(24px, env(safe-area-inset-left, 24px));
  box-sizing: border-box;
  overflow: hidden;
  animation: ltDuckFadeIn 0.25s ease-out;
}

@keyframes ltDuckFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.lt-duck-mode__dim-hud {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  text-align: center;
  max-width: 380px;
  width: 100%;
  opacity: 0.38;
  transition: opacity 0.3s ease;
}

.lt-duck-mode:hover .lt-duck-mode__dim-hud,
.lt-duck-mode:active .lt-duck-mode__dim-hud {
  opacity: 0.75;
}

.lt-duck-mode__status-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #94a3b8;
}

.lt-duck-mode__dot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  color: #10b981;
}

.lt-duck-mode__dot--rec {
  color: #ef4444;
  animation: ltDuckPulse 1.4s infinite cubic-bezier(0.4, 0, 0.6, 1);
}

@keyframes ltDuckPulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.4;
    transform: scale(0.85);
  }
}

.lt-duck-mode__table-badge {
  padding: 2px 7px;
  border-radius: 6px;
  background: rgba(0, 242, 254, 0.12);
  color: #00f2fe;
  font-weight: 800;
  font-size: 0.72rem;
  letter-spacing: 0.04em;
}

.lt-duck-mode__timer {
  font-size: clamp(3rem, 14vw, 4.5rem);
  font-weight: 800;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.03em;
  color: #94a3b8;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.lt-duck-mode__ex-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: #64748b;
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lt-duck-mode__wake-hint {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: #475569;
  margin-top: 8px;
}

.lt-duck-mode__wake-icon {
  font-size: 1rem !important;
  opacity: 0.6;
}

.lt-duck-mode__wake-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
  padding: 10px 20px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #f8fafc;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.2s ease;
}

.lt-duck-mode__wake-btn:hover {
  background: rgba(255, 255, 255, 0.16);
  border-color: rgba(255, 255, 255, 0.3);
  transform: scale(1.03);
}

.lt-duck-mode__wake-btn:active {
  transform: scale(0.97);
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingDuckMode.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;;AAE/E;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B;;;8CAG4C;EAC5C,sBAAsB;EACtB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iEAAiE;AACnE;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,uBAAuB;EACvB,cAAc;EACd,yFAAyF;AAC3F;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/* ─── LIVE TRAINING DUCK MODE (OLED ENERGY SAVER) ──────────────────────────\n   Pure #000000 background to turn off OLED pixels and eliminate battery drain\n   and thermal throttling while filming with the back camera.\n   Wake lock remains active so the phone OS does not suspend the camera stream.\n   ────────────────────────────────────────────────────────────────────────── */\n\n.lt-duck-mode {\n  position: fixed;\n  inset: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 99999;\n  background: #000000 !important;\n  color: #64748b;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  padding: max(24px, env(safe-area-inset-top, 24px))\n    max(24px, env(safe-area-inset-right, 24px))\n    max(28px, env(safe-area-inset-bottom, 28px))\n    max(24px, env(safe-area-inset-left, 24px));\n  box-sizing: border-box;\n  overflow: hidden;\n  animation: ltDuckFadeIn 0.25s ease-out;\n}\n\n@keyframes ltDuckFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.lt-duck-mode__dim-hud {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  text-align: center;\n  max-width: 380px;\n  width: 100%;\n  opacity: 0.38;\n  transition: opacity 0.3s ease;\n}\n\n.lt-duck-mode:hover .lt-duck-mode__dim-hud,\n.lt-duck-mode:active .lt-duck-mode__dim-hud {\n  opacity: 0.75;\n}\n\n.lt-duck-mode__status-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.lt-duck-mode__dot {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  color: #10b981;\n}\n\n.lt-duck-mode__dot--rec {\n  color: #ef4444;\n  animation: ltDuckPulse 1.4s infinite cubic-bezier(0.4, 0, 0.6, 1);\n}\n\n@keyframes ltDuckPulse {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.4;\n    transform: scale(0.85);\n  }\n}\n\n.lt-duck-mode__table-badge {\n  padding: 2px 7px;\n  border-radius: 6px;\n  background: rgba(0, 242, 254, 0.12);\n  color: #00f2fe;\n  font-weight: 800;\n  font-size: 0.72rem;\n  letter-spacing: 0.04em;\n}\n\n.lt-duck-mode__timer {\n  font-size: clamp(3rem, 14vw, 4.5rem);\n  font-weight: 800;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.03em;\n  color: #94a3b8;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.lt-duck-mode__ex-name {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #64748b;\n  max-width: 90%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.lt-duck-mode__wake-hint {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  color: #475569;\n  margin-top: 8px;\n}\n\n.lt-duck-mode__wake-icon {\n  font-size: 1rem !important;\n  opacity: 0.6;\n}\n\n.lt-duck-mode__wake-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 14px;\n  padding: 10px 20px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  color: #f8fafc;\n  font-size: 0.82rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.lt-duck-mode__wake-btn:hover {\n  background: rgba(255, 255, 255, 0.16);\n  border-color: rgba(255, 255, 255, 0.3);\n  transform: scale(1.03);\n}\n\n.lt-duck-mode__wake-btn:active {\n  transform: scale(0.97);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
